// extracted by mini-css-extract-plugin
export default {"control":"Input_control__rmL26","suffix":"Input_suffix__P26OH"};